<template>
  <v-app id="inspire">
    <div v-if="authStore.user !== null && showNavBar">
      <v-app-bar>
        <v-app-bar-nav-icon @click="drawer = !drawer"/>
        <v-app-bar-title>
          <router-link to="/" class="headtitle">Super Admin</router-link>
        </v-app-bar-title>
        <v-spacer/>
        <v-menu style="z-index: 2001;">
          <template #activator="{ props }">
            <v-btn v-bind="props" icon>
              <img style="max-height: 30px" :src="flag_icons[locale]" :alt="locale"/>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="language in selectable_languages"
              :key="language"
              @click="locale = language"
            >
              <img style="max-height: 30px" :src="flag_icons[language]" :alt="language"/>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-app-bar>
      <v-navigation-drawer v-model="drawer" temporary>
        <v-list-item to="/"><h1>Home</h1></v-list-item>
        <v-list-item><b>{{ authStore.user.username }}</b></v-list-item>
        <v-list-item @click="authStore.logout()">Logout</v-list-item>
        <v-divider/>
        <template v-for="cat in schema">
          <v-list-item><h3>{{ cat.name }}</h3></v-list-item>
          <v-list-item v-for="s in cat.routes" :to="s.route">{{ s.name }}</v-list-item>
          <v-divider/>
        </template>
      </v-navigation-drawer>
    </div>
    <v-main class="bg-grey-lighten-4">
      <router-view/>
    </v-main>
  </v-app>
</template>

<script setup lang="ts">
import { useAuthStore } from "@/store/authstore";
import { onMounted, onUnmounted, ref, computed, shallowRef, watch } from "vue";
import { schema } from "./router/pages";
import { useRoute } from "vue-router";
import { useI18n } from 'vue-i18n';

import { SUPPORTED_LANGUAGES } from "@/i18n_config";
import itFlagIcon from '@/assets/flags/it.png';
import frFlagIcon from '@/assets/flags/fr.png';
import enFlagIcon from '@/assets/flags/en.png';
import nlFlagIcon from '@/assets/flags/nl.png';
import deFlagIcon from '@/assets/flags/de.png';

const authStore = useAuthStore();
const { locale } = useI18n({ useScope: 'global' });
watch(locale, (newVal) => {
  localStorage.setItem('superadmin_locale', newVal);
});

const route = useRoute();

const showNavBar = computed(() => {
  return !(route.meta['hideNavBar'] || false);
});

const drawer = ref(false);

let userpoller: NodeJS.Timeout;

async function userPollerFunc() {
  const isPublic = route.meta['isPublic'] || false;
  if (isPublic === false) {
    await authStore.pollIfLogged(route);
  }
}

onMounted(async () => {
  await userPollerFunc();
  userpoller = setInterval(userPollerFunc, 30000);

  const saved_locale = localStorage.getItem('superadmin_locale');
  if (saved_locale !== null) {
    locale.value = saved_locale;
  }
});

onUnmounted(() => {
  clearInterval(userpoller);
});


// Languages

interface FlagIcons {
  [key: string]: string;
}

const flag_icons = shallowRef<FlagIcons>({
  "it": itFlagIcon,
  "en": enFlagIcon,
  "fr": frFlagIcon,
  "nl": nlFlagIcon,
  "de": deFlagIcon
});

const selectable_languages = computed(() => {
  return Object.keys(SUPPORTED_LANGUAGES).filter((lang) => lang !== locale.value);
});
</script>

<style scoped>
a {
  cursor: pointer;
}

.headtitle {
  text-decoration: none;
  color: inherit;
}

.headtitle:hover {
  font-size: 120%;
  text-shadow: 2px 2px 4px red;
  transition: font-size 0.3s ease, text-shadow 0.3s ease;
}
</style>
